<template>
  <div class="wrapper">
    <div class="logo">
      <img src="@/assets/brief/logo.png" />
    </div>
    <!-- <van-search
      v-model="value"
      shape="round"
      placeholder="搜索医生姓名"
      @input="handleQuery"
    >
      <template v-slot:left-icon>
        <img src="@/assets/payment/sousuo_icon.png" class="ss_icon" />
      </template>
    </van-search> -->
    <van-dropdown-menu>
      <van-dropdown-item v-model="value1" :options="option1" @change="select" />
    </van-dropdown-menu>
    <ul class="doctorSel" v-if="list.length != 0?true:false">
      <li v-for="item in list" :key="item.drcode" @click="go(item)">
        <img :src="item.img" />
        <div>
          <p class="doctor_name">
            <span>{{ item.drname }}</span>
            <span>{{ item.professional }}</span>
          </p>
          <!-- <p style="margin: 5px 0px">XXX科室</p> -->
          <p>擅长：{{ item.introduce }}</p>
        </div>
        <img src="@/assets/appointment/xsj_r.png" class="yybtn_cl" />
      </li>
    </ul>
    <div class="drnone" v-if="list.length == 0?true:false">
      暂无
    </div>
  </div>
</template>

<script>
import { selectBDeptinfo, selectBDoctorinfo } from "@/request/api.js";
export default {
  data() {
    return {
      value: "",
      value1: "",
      option1: [{ text: "全部科室", value: "" }],
      showIf: true,
      list: []
    };
  },
  async created() {
    let map = {
      queryRequest: {
        pageNum: 1,
        pageSize: 500,
        sortField: "",
        sortOrder: ""
      }
    };
    let res = await selectBDeptinfo(map);
    res.data.obj.records.forEach(item => {
      this.option1.push({
        text: item.deptName,
        value: item.deptCode
      });
    });
    this.handleQuery();
  },
  methods: {
    async handleQuery() {
      let map = {
        deptCode: this.value1,
        drname: this.value,
        queryRequest: {
          pageNum: 1,
          pageSize: 500,
          sortField: "",
          sortOrder: ""
        }
      };
      let res = await selectBDoctorinfo(map);
      this.list = res.data.obj.records;
    },
    makebtn() {
      console.log(111);
    },
    select(value) {
      console.log(value);
      this.handleQuery();
    },
    go(item) {
      sessionStorage.setItem("doctorDetails",JSON.stringify(item))
      this.$router.push("/experts/doctorDetails");
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #f8f8f8;
  position: relative;
  .logo {
    widows: 375px;
    height: 183px;
    > img {
      widows: 100%;
      height: 100%;
    }
  }
  /deep/ .van-search {
    position: absolute;
    top: 70px;
    left: 0px;
    width: 100%;
    background: transparent;
  }
  /deep/ .van-dropdown-menu {
    position: absolute;
    top: 160px;
    width: 355px;
    height: 82px;
    margin: 0px 10px;
  }
  .ss_icon {
    position: relative;
    top: 2px;
    width: 11px;
    height: 13px;
  }
  .doctorSel {
    display: flex;
    flex-flow: column nowrap;
    margin: 40px 10px 10px;
    > li {
      position: relative;
      margin-bottom: 10px;
      padding: 10px;
      background: #fff;
      display: flex;
      flex-flow: row;
      flex-flow: row nowrap;
      > img {
        width: 54px;
        height: 66px;
      }
      > div {
        margin: 0px 40px 0px 15px;
        color: #aeaeae;
        font-size: 12px;
        flex: 1;
        display: flex;
        flex-flow: column nowrap;
        justify-content: space-around;
        .doctor_name {
          > span:nth-child(1) {
            font-size: 18px;
            font-weight: bold;
            color: #000;
            margin-right: 4px;
          }
          > span:nth-child(2) {
            position: relative;
            bottom: 0px;
          }
        }
        > p:nth-child(3) {
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          > img {
            width: 18px;
            position: absolute;
            bottom: 10px;
            right: 30px;
          }
        }
      }
      .yybtn_cl {
        position: absolute;
        width: 16px;
        height: 22px;
        top: 16px;
        right: 14px;
      }
    }
  }
  .drnone{
    margin: 80px 10px 10px;
    text-align: center;
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/website/experts/experts.vue